import { Col, Row } from 'antd';
import * as React from 'react';
import { UserName } from '../name_component/user/UserNameComponent';
import DateTimeHover from '../date_time_component/DateTime';
import {
	contactObjectExists,
	getWorkOrderTimeZoneId,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';

export default function ForwardedDetails({ details, item }) {
	const { forwardedAt, forwardedBy, forwardedByContact } = details;

	return (
		<Row className={'justify-end'}>
			<span style={{ fontSize: 12.5, color: 'rgba(0,0,0,0.45)' }}>
				Forwarded for approval by{' '}
				{contactObjectExists(forwardedByContact) ? (
					<UserName
						contact={forwardedByContact}
						mode={'inline'}
						details={[]}
						extraDetails={[
							{
								key: 'forwardedAt',
								display: 'Forwarded',
								value: (
									<DateTimeHover
										timestamp={forwardedAt}
										timeZone={getWorkOrderTimeZoneId(nullSafeGet('workOrder', item))}
									/>
								),
							},
						]}
					/>
				) : (
					forwardedBy
				)}
			</span>
		</Row>
	);
}
